<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="accountModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">Account
              <template v-if="account">
                <i v-if="fieldsMissing" class="fa fa-warning text-danger" />
                <i v-else class="fa fa-check-square text-success" />
              </template>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loader"></div>
            <section v-else-if="account">
              <h5>IP</h5>
              <div class="row">
                <div class="col-md-12">
                  <b>Server IP</b><br>
                  {{ (account.serverIP === '') ? 'Not available yet' : account.serverIP }}
                </div>
              </div>
              <hr class="h-3">
              <h5>FTP Details</h5>
              <div class="row">
                <div class="col-md-4">
                  <b>FTP Hostname</b><br>
                  <span class="overlap-text">
                  {{ (account.ftp.host === '') ? 'Not available yet' : account.ftp.host }}
                  </span>
                  <a href="javascript:void(0)" class="ml-1" @click="doCopy(account.ftp.host)"><i class="fa fa-copy"></i></a>
                </div>
                <div class="col-md-4">
                  <b>FTP Port</b><br>
                  <span class="overlap-text">
                  {{ (account.ftp.port === '') ? 'Not available yet' : account.ftp.port }}
                  </span>
                </div>
                <div class="col-md-4">
                  <b>FTP Mode</b><br>
                  <span class="overlap-text">
                  {{(account.ftp.mode === '') ? 'Not available yet' : account.ftp.mode}}
                  </span>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-4">
                  <b>FTP Passive (PASV)</b><br>
                  <span class="overlap-text">
                  {{(account.ftp.pasv === '') ? 'Not available yet' : account.ftp.pasv}}
                  </span>
                </div>
                <div class="col-md-4">
                  <b>FTP Username</b><br>
                  <span class="overlap-text">
                  {{(account.ftp.username === '') ? 'Not available yet' : account.ftp.username}}
                  </span>
                </div>
                <div class="col-md-4">
                  <b>FTP Password</b><br>
                  <span class="overlap-text">
                  {{ (account.ftp.password === '') ? 'Not available yet' : account.ftp.password }}
                  </span>
                </div>
              </div>
              <hr class="h-3">
              <h5>PHP-My-Admin Details</h5>
              <!-- phpMyAdmin Details -->
              <div class="row">
                <div class="col-md-4">
                  <b>phpMyAdmin URL</b><br>
                  <span class="overlap-text">
                  {{(account.phpMyAdmin.url === '') ? 'Not available yet' : account.phpMyAdmin.url}}
                  </span>
                </div>
                <div class="col-md-4">
                  <b>phpMyAdmin Poup Username</b><br>
                  <span class="overlap-text">
                  {{(account.phpMyAdmin.popupUsername === '') ? 'Not available yet' : account.phpMyAdmin.popupUsername}}
                  </span>
                </div>
                <div class="col-md-4">
                  <b>phpMyAdmin Popup Password</b><br>
                  <span class="overlap-text">
                  {{(account.phpMyAdmin.popupPassword === '') ? 'Not available yet' : account.phpMyAdmin.popupPassword}}
                  </span>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-4">
                  <b>phpMyAdmin Username</b><br>
                  <span class="overlap-text">
                  {{ (account.phpMyAdmin.username === '') ? 'Not available yet' : account.phpMyAdmin.username}}
                  </span>
                </div>
                <div class="col-md-4">
                  <b>phpMyAdmin Password</b><br>
                  <span class="overlap-text">
                  {{ (account.phpMyAdmin.password === '') ? 'Not available yet' : account.phpMyAdmin.password }}
                  </span>
                </div>
              </div>
              <hr class="h-3">
              <h5>Cloudflare Details</h5>
              <!-- Section to show Cloudflare Details -->
              <div class="row">
                <div class="col-md-4">
                  <b>Cloudflare Username</b><br>
                  <span class="overlap-text">
                  {{ (account.cloudflare.username === '') ? 'Not available yet' : account.cloudflare.username}}
                  </span>
                </div>
                <div class="col-md-4">
                  <b>Cloudflare Password</b><br>
                  <span class="overlap-text">
                  {{(account.cloudflare.password === '') ? 'Not available yet' : account.cloudflare.password}}
                  </span>
                </div>
                <div class="col-md-4">
                  <b>Cloudflare Userkey</b><br>
                  <span class="overlap-text">
                  {{ (account.cloudflare.userKey === '') ? 'Not available yet' : account.cloudflare.userKey}}
                  </span>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-4">
                  <b>Cloudflare Nameserver 1</b><br>
                  <span class="overlap-text">
                  {{(account.cloudflare.nameserver1 === '') ? 'Not available yet' : account.cloudflare.nameserver1}}
                  </span>
                  <a v-if="account.cloudflare.nameserver1" href="javascript:void(0)" class="ml-1" @click="doCopy(account.cloudflare.nameserver1)"><i class="fa fa-copy"></i></a>
                </div>
                <div class="col-md-4">
                  <b>Cloudflare Nameserver 2</b><br>
                  <span class="overlap-text">
                    {{ (account.cloudflare.nameserver2 === '') ? 'Not available yet' : account.cloudflare.nameserver2}}
                  </span>
                  <a v-if="account.cloudflare.nameserver2" href="javascript:void(0)" class="ml-1" @click="doCopy(account.cloudflare.nameserver2)"><i class="fa fa-copy"></i></a>
                </div>
                <div class="col-md-4">
                  <b>Cloudflare API key</b><br>
                  <span class="overlap-text">
                    {{ (account.cloudflare.apiKey === '') ? 'Not available yet' : account.cloudflare.apiKey}}
                  </span>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-4">
                  <b>Cloudflare Zone id</b><br>
                  <span class="overlap-text">
                    {{(account.cloudflare.zone_id === '') ? 'Not available yet' : account.cloudflare.zone_id}}
                  </span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { db } from '@/firebase/init'
  export default {
    name: "accountModal",
    data() {
      return {
        loading: false,
        account: null
      }
    },
    computed: { //|| this.account === ''
      fieldsMissing () {
        if(this.account) {
          return (this.account.serverIP === '' || this.account.ftp.host === ''
            || this.account.ftp.username === '' || this.account.ftp.password === ''|| this.account.phpMyAdmin.url === ''
            || this.account.phpMyAdmin.popupUsername === '' || this.account.phpMyAdmin.popupPassword === ''
            || this.account.phpMyAdmin.username === '' || this.account.phpMyAdmin.password === ''
            || this.account.cloudflare.username === '' || this.account.cloudflare.password === ''
            || this.account.cloudflare.userKey === '' || this.account.cloudflare.nameserver1 === ''
            || this.account.cloudflare.nameserver2 === '' || this.account.cloudflare.apiKey === ''
            || this.account.cloudflare.zone_id === '' )
        } else {
          return true
        }
      }
    },
    methods: {
      doCopy(text) {
        const textField = document.createElement('textarea');
        textField.innerText = text;
        document.body.appendChild(textField);
        textField.select();
        textField.focus(); //SET FOCUS on the TEXTFIELD
        document.execCommand('copy');
        textField.remove();
        console.log('should have copied ' + text);
        this.$notify({
          group: 'foo',
          title: 'Message',
          text: 'Copied!'
        });
      },
      async load (migration) {
        $('#accountModal').modal('show');
        $('.modal-backdrop').removeClass("modal-backdrop");
        this.loading = true
        let accounts = await db.collection('hostingAccounts').doc(migration.uid).get()
        accounts = accounts.data().accounts
        for (let acc of accounts) {
          if (acc.primary.domain === migration.siteDetails.domainName) {
            this.account = acc.primary
            this.loading = false
            return
          }
          for (let addon of acc.addon) {
            if (addon.domain === migration.siteDetails.domainName) {
              this.account = addon
              this.loading = false
              return
            }
          }
        }
      }
    }
  }
</script>

<style  lang="scss" scoped>
  .overlap-text{
    width: 100%;
    word-break: break-all;
  }
  hr {
    &.h-3 {
       border-top: 3px solid rgba(0,0,0,.1);
     }
  }
</style>
